import { Box } from '@mui/material';
import RachelInputView from '../../rachel/components/RachelInput/RachelInputView';
import { useRachelInput } from '../../rachel/components/RachelInput/useRachelInput';
import { useIsRachelAvailable } from '../../rachel/hooks/useIsRachelAvailable';
import { useRachelSubmit } from '../../rachel/hooks/useRachelSubmit';

const HOME_RACHEL_INPUT_MAX_WIDTH = 640;

const HOME_RACHEL_INPUT_MIN_HEIGHT = 40;

const HomeRachelInputContent = () => {
  const rachelSubmit = useRachelSubmit({ shouldStartNewChat: true });
  const {
    value,
    setValue,
    hasText,
    isActive,
    isMultiline,
    isStreaming,
    measureRef,
    setIsHovered,
    stop,
    handleSend,
    handleKeyDown,
    handleFocus,
    handleBlur,
  } = useRachelInput({ rachelSubmit, shouldOpenOnFocus: false, shouldOpenPageOnSend: true });

  return (
    <Box sx={{ width: '100%', maxWidth: HOME_RACHEL_INPUT_MAX_WIDTH, mx: 'auto' }}>
      <RachelInputView
        minHeight={HOME_RACHEL_INPUT_MIN_HEIGHT}
        expandDirection="down"
        isRound
        value={value}
        isActive={isActive}
        isVertical={isMultiline}
        isStreaming={isStreaming}
        hasText={hasText}
        inputRef={measureRef}
        onChange={setValue}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        onSend={handleSend}
        onStop={stop}
        onHoverChange={setIsHovered}
      />
    </Box>
  );
};

const HomeRachelInput = () => {
  const isAvailable = useIsRachelAvailable();
  if (!isAvailable) {
    return null;
  }
  return <HomeRachelInputContent />;
};

export default HomeRachelInput;
